import { FiltersComponentInterface, FiltersTypeEnum } from 'world-archery-lib';
import { BehaviorSubject, combineLatest } from 'rxjs';
import { FiltersAbstractService } from '../../../../common-page-components/classes/filters-abstract-service';
import { TextFilter } from 'src/app/common-page-components/stores/filters-store/filters-store';
import { distinctUntilChanged, debounceTime } from 'rxjs/operators';
import * as i0 from "@angular/core";
export class FiltersInterpretationService extends FiltersAbstractService {
    constructor() {
        super();
        this.textFilter = new TextFilter('rbfilter');
        this.filtersType = [
            this.textFilter.filterInfo,
            {
                options: {
                    type: FiltersTypeEnum.RangeDateSimpleFilter,
                    hideFilter: true,
                    date_from: {
                        type: FiltersTypeEnum.DateFilter,
                        date_format: 'dd MMMM yyyy',
                        placeholder: 'From:',
                        date_subject: new BehaviorSubject(this.getDateDefault()),
                        id: 'rbidatefrom'
                    },
                    date_to: {
                        type: FiltersTypeEnum.DateFilter,
                        date_format: 'dd MMMM yyyy',
                        placeholder: 'To:',
                        date_subject: new BehaviorSubject({}),
                        id: 'rbidateto'
                    }
                }
            },
        ];
    }
    /**
     * {@inheritdoc}
     *
     * @returns {[]}
     * @memberof FiltersInterpretationService
     */
    getDataStreamWithFilters() {
        return combineLatest([this.orderValue, this.textFilter.data().pipe(distinctUntilChanged(), debounceTime(300)),
            this.filtersType[1].options.date_from.date_subject.asObservable(),
            this.filtersType[1].options.date_to.date_subject.asObservable()]);
    }
    /**
     * Get default date for filters.
     *
     * @return Date
     *   From now.
     */
    getDateDefault() {
        const date = new Date(), y = date.getFullYear(), m = date.getMonth();
        return { value: date };
    }
    generateDefaultValues() {
        return;
    }
}
FiltersInterpretationService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function FiltersInterpretationService_Factory() { return new FiltersInterpretationService(); }, token: FiltersInterpretationService, providedIn: "root" });
